export default __webpack_public_path__ + "static/media/img-05-khomsan.4762d807.jpg";